var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConnApi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 98,
    viewBox: "0 0 98 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H89.6641C94.0823 0 97.6641 3.58172 97.6641 8V89.6641C97.6641 94.0823 94.0823 97.6641 89.6641 97.6641H8C3.58172 97.6641 0 94.0823 0 89.6641V8Z",
    fill: "#FFE7EF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2575 52.7574V52.7574C28.2575 58.225 32.6899 62.6574 38.1575 62.6574H43.2662C43.3087 62.6574 43.3432 62.623 43.3432 62.5805V42.9344C43.3432 42.8919 43.3087 42.8574 43.2662 42.8574H38.1575C32.6899 42.8574 28.2575 47.2898 28.2575 52.7574V52.7574ZM28.2575 52.7574H22.1289",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2575 52.7555C28.2575 47.2879 32.6899 42.8555 38.1575 42.8555H43.2662C43.3087 42.8555 43.3432 42.8899 43.3432 42.9324V62.5785C43.3432 62.621 43.3087 62.6555 43.2662 62.6555H38.1575C32.6899 62.6555 28.2575 58.2231 28.2575 52.7555Z",
    fill: "#FFF8DE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2575 52.7555V52.7555C28.2575 58.2231 32.6899 62.6555 38.1575 62.6555H43.2662C43.3087 62.6555 43.3432 62.621 43.3432 62.5785V42.9324C43.3432 42.8899 43.3087 42.8555 43.2662 42.8555H38.1575C32.6899 42.8555 28.2575 47.2879 28.2575 52.7555V52.7555ZM28.2575 52.7555H22.1289",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6063 52.7574V52.7574C69.6063 58.225 65.174 62.6574 59.7063 62.6574H54.2641C54.2206 62.6574 54.1854 62.6222 54.1854 62.5787V55.3503M69.6063 52.7574V52.7574C69.6063 47.2898 65.174 42.8574 59.7063 42.8574H54.2641C54.2206 42.8574 54.1854 42.8926 54.1854 42.9361V49.9289M69.6063 52.7574H75.8711M54.1854 49.9289H47.114M54.1854 49.9289V55.3503M54.1854 55.3503H47.114",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6063 52.7555C69.6063 47.2879 65.174 42.8555 59.7063 42.8555H54.2641C54.2206 42.8555 54.1854 42.8907 54.1854 42.9341V49.9269V55.3483V62.5768C54.1854 62.6202 54.2206 62.6555 54.2641 62.6555H59.7063C65.174 62.6555 69.6063 58.2231 69.6063 52.7555Z",
    fill: "#FFF8DE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6063 52.7555V52.7555C69.6063 58.2231 65.174 62.6555 59.7063 62.6555H54.2641C54.2206 62.6555 54.1854 62.6202 54.1854 62.5768V55.3483M69.6063 52.7555V52.7555C69.6063 47.2879 65.174 42.8555 59.7063 42.8555H54.2641C54.2206 42.8555 54.1854 42.8907 54.1854 42.9341V49.9269M69.6063 52.7555H75.8711M54.1854 49.9269H47.114M54.1854 49.9269V55.3483M54.1854 55.3483H47.114",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16 32.9571H82M16 32.9571V73.9143C16 74.4666 16.4477 74.9143 17 74.9143H81C81.5523 74.9143 82 74.4666 82 73.9143V32.9571M16 32.9571V25C16 24.4477 16.4477 24 17 24H81C81.5523 24 82 24.4477 82 25V32.9571",
    stroke: "black",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.1291,
    cy: 28.2424,
    r: 1.41429,
    fill: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.842,
    cy: 28.2424,
    r: 1.41429,
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnApi);
export default __webpack_public_path__ + "static/media/conn_api.5fc4aff60cff146d42398ddb9c1da659.svg";
export { ForwardRef as ReactComponent };